var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.paymentStatus},[_c('div',{class:[_vm.$style.circle, _vm.color]}),_c('div',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.status)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }